<template>
  <div data-test-id="datasetsView">
    <DataTable
      :editable="appStore.isProgramAdmin"
      :row-props="colorActiveRow"
      :protected-item-ids="protectedItemIds"
      :disable-delete-message="t('warnings.deleteActiveDataset')"
      :table-store-id="TableStoreId.Datasets"
      :delete-message="deleteMessage"
      :delete-title="t('dialogs.headers.deleteDataset')"
      @new="createNewItem"
      @delete="onDelete"
    >
      <template v-slot:footer>
        <EditDataset />
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { TableStoreId } from '@/enums/TableStoreId'
import type { IDatasetStore } from '@/interfaces/api/IDatasetStore'
import { DatasetRecord } from '@/models/DatasetRecord'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { useAppStore } from '@/stores/ui/AppStore'
import { useSettingsStore } from '@/stores/ui/SettingsStore'
import Colors from '@/styles/_colors.module.scss'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const appStore = useAppStore()
const settingsStore = useSettingsStore()
const store = TableStoreFactory.get(TableStoreId.Datasets) as IDatasetStore

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const deleteMessage = computed((): string => {
  return t('dialogs.delete.datasetWarning', { name: store.selectedItem?.name })
})

const protectedItemIds = computed(() => {
  return [settingsStore.activeDatasetId]
})

// LIFECYCLE HOOKS

// FUNCTIONS
const colorActiveRow = (row: any) => {
  if (row.item.id === settingsStore.activeDatasetId) {
    return { style: `background-color: ${Colors.mainAccent};` }
  }
}

const createNewItem = () => {
  store.createNewItem(new DatasetRecord())
}

const onDelete = async () => {
  await store.loadEnabled()
}
</script>

<style lang="scss" scoped>
.active-row {
  background-color: red;
  font-weight: bold;
}
</style>
